module.exports = __webpack_public_path__ + "static/media/bg-simbolo-logo.1d7fd3c8.svg";